export default "__VITE_ASSET__6f27ca98__"